/**
 * @license @tabler/icons-react v3.17.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadge8kFilled = createReactComponent("filled", "badge-8k-filled", "IconBadge8kFilled", [["path", { "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-1.445 4.168a1 1 0 0 0 -1.387 .277l-1.168 1.751v-1.196a1 1 0 0 0 -.883 -.993l-.117 -.007a1 1 0 0 0 -1 1v6a1 1 0 0 0 2 0v-1.196l1.168 1.75a1 1 0 0 0 1.286 .337l.1 -.059l.094 -.07a1 1 0 0 0 .184 -1.317l-1.63 -2.445l1.63 -2.445a1 1 0 0 0 -.277 -1.387m-8.555 -.168h-1a2 2 0 0 0 -2 2v1l.005 .15c.022 .295 .108 .573 .245 .819l.019 .031l-.02 .031a2 2 0 0 0 -.249 .969v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-1l-.005 -.15a2 2 0 0 0 -.245 -.819l-.019 -.031l.02 -.031c.158 -.287 .249 -.618 .249 -.969v-1a2 2 0 0 0 -2 -2m0 5v1h-1v-1zm0 -3v1h-1v-1z", "key": "svg-0" }]]);

export { IconBadge8kFilled as default };
//# sourceMappingURL=IconBadge8kFilled.mjs.map
